var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogVisible)?_c('div',{staticClass:"bigImage-all"},[_c('span',[_c('i',{staticClass:"el-icon-close",on:{"click":_vm.close}})]),_c('img',{attrs:{"src":_vm.domain + _vm.image,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }